export default function HomeIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M17.3584 7.1751L11.9 2.80843C10.8334 1.95843 9.16672 1.9501 8.10838 2.8001L2.65005 7.1751C1.86672 7.8001 1.39172 9.0501 1.55838 10.0334L2.60838 16.3168C2.85005 17.7251 4.15838 18.8334 5.58338 18.8334H14.4167C15.825 18.8334 17.1584 17.7001 17.4 16.3084L18.45 10.0251C18.6 9.0501 18.125 7.8001 17.3584 7.1751Z"
        fill="currentColor"
      />
      <path
        d="M10 16.125C9.65833 16.125 9.375 15.8417 9.375 15.5V13C9.375 12.6583 9.65833 12.375 10 12.375C10.3417 12.375 10.625 12.6583 10.625 13V15.5C10.625 15.8417 10.3417 16.125 10 16.125Z"
        fill="currentColor"
      />
    </svg>
  );
}
